import React from 'react';
import GridImage from './GridImage';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const RatpProjectGrid = (props) => {
    let currentProjectIndex = props.projects.findIndex(project => project.path === props.path);
    let gridImages = props.projects[currentProjectIndex].gridImages;
    return (
        <div>
            <div className="project-slide"></div>
            <div className="project-grid ratp-project container">
                <div className="flex">
                    <svg className="grid-svg-1" x="0px" y="0px" width="13" height="530" viewBox="0 0 13 530">
                        <text className="ratp-text barlow-bo" x="0" y="10" fill="#000">
                            <tspan x="0">R</tspan>
                            <tspan x="0" dy="168">A</tspan>
                            <tspan x="0" dy="168">T</tspan>
                            <tspan x="0" dy="168">P</tspan>
                        </text>
                        <text className="ratp-text barlow-re" x="0" y="10" fill="#000">
                            <tspan x="8.5">r</tspan>
                            <tspan x="8.5" dy="168">a</tspan>
                            <tspan x="8.5" dy="168">t</tspan>
                            <tspan x="8.5" dy="168">p</tspan>
                        </text>
                    </svg>
                    {/*<img className="grid-img-1" src="/assets/img/homes/ratp/02.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-1', asset: gridImages[1], sizes: ''}}/>
                    <svg className="grid-svg-2" x="0px" y="0px" width="178" height="120" viewBox="0 0 178 120">
                        <text className="ratp-text2 yrsa-li" x="0" y="10" fill="#af2100" textLength="1750">
                            <tspan x="0">ratpratp</tspan>
                            <tspan x="0">ratpratp</tspan>
                            <tspan x="0">ratpratp</tspan>

                            <tspan x="0" dy="54">ratpratp</tspan>
                            <tspan x="0" dy="54">ratpratp</tspan>
                            <tspan x="0" dy="54">ratpratp</tspan>

                            <tspan x="0" dy="108">ratpratp</tspan>
                            <tspan x="0" dy="108">ratpratp</tspan>
                            <tspan x="0" dy="108">ratpratp</tspan>
                        </text>
                    </svg>
                </div>
                {/*<img className="grid-img-2" src="/assets/img/homes/ratp/03.jpg" alt=""/>*/}
                <GridImage params={{className: 'grid-img-2', asset: gridImages[2], sizes: ''}}/>
                <div className="flex credits-container">
                    <div className="credits desktop">
                        <span className="credits-title red">Credits</span>
                        <ul className="no-style">
                            <li><span className="red barlow-me">Client</span> RATP</li>
                            <li><span className="red barlow-me">Agency</span> Havas Worldwide</li>
                            <li><span className="red barlow-me">Art Purchase / Achat d’art</span> Pia Schneider</li>
                            <li><span className="red barlow-me">Photographer</span> Nick & Chloé</li>
                            <li><span className="red barlow-me">Art Director</span> Catherine Labro<br/>& Sylvain Louradour</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

// export default RatpProjectGrid;
const mapStateToProps = (state) => {
    return {
        projects: state.assets.projects
    };
};

export default withRouter(connect(mapStateToProps, null)(RatpProjectGrid));


// WEBPACK FOOTER //
// ./src/components/RatpProjectGrid.js